import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Header from './components/Header'
import Main from './components/Main'
import Footer from './components/Footer'
import AppScss from './App.module.scss'

class App extends React.Component {
  render() {
    const theme = createTheme({
      palette: {
        primary: { main: '#3abc95', contrastText: '#fff' }
      }
    })
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Header />
          <Box component="main" sx={{ flexGrow: 1 }} className={AppScss.App}>
            <Main />
          </Box>
          {/* 明示的に渡したい場合: <Footer version="1.2.3" /> */}
          <Footer />
        </Box>
      </ThemeProvider>
    )
  }
}

export default App
